import { render, staticRenderFns } from "./OrganizationItem.vue?vue&type=template&id=cb493bc0&"
import script from "./OrganizationItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb493bc0')) {
      api.createRecord('cb493bc0', component.options)
    } else {
      api.reload('cb493bc0', component.options)
    }
    module.hot.accept("./OrganizationItem.vue?vue&type=template&id=cb493bc0&", function () {
      api.rerender('cb493bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/organizations/OrganizationItem.vue"
export default component.exports